import { render, staticRenderFns } from "./avalonNewsSingle.vue?vue&type=template&id=fe58432a&scoped=true&"
import script from "./avalonNewsSingle.vue?vue&type=script&lang=js&"
export * from "./avalonNewsSingle.vue?vue&type=script&lang=js&"
import style0 from "./avalonNewsSingle.vue?vue&type=style&index=0&id=fe58432a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe58432a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VImg,VSheet})
